var _a;
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CancelIcon from "@mui/icons-material/Cancel";
import InfoIcon from "@mui/icons-material/Info";
import VerifiedIcon from "@mui/icons-material/Verified";
export var KycStatus;
(function (KycStatus) {
    KycStatus["DRAFT"] = "DRAFT";
    KycStatus["SUBMITTED"] = "SUBMITTED";
    KycStatus["REJECTED"] = "REJECTED";
    KycStatus["VERIFIED"] = "VERIFIED";
})(KycStatus || (KycStatus = {}));
export var statusKYC = (_a = {},
    _a[KycStatus.DRAFT] = {
        icon: InfoIcon,
        color: "#9ca3af",
        title: "kyc-profile.status.draft.title",
        description: "kyc-profile.status.draft.description",
        button: "kyc-profile.button.verification",
        link: "/registration/personal-information",
    },
    _a[KycStatus.SUBMITTED] = {
        icon: AccessTimeIcon,
        color: "#facc15",
        title: "kyc-profile.status.submitted.title",
        description: "kyc-profile.status.submitted.description",
    },
    _a[KycStatus.REJECTED] = {
        icon: CancelIcon,
        color: "#e7000b",
        title: "kyc-profile.status.rejected.title",
        description: "kyc-profile.status.rejected.description",
        message: true,
        button: "kyc-profile.button.retryVerification",
        link: "/registration/personal-information",
    },
    _a[KycStatus.VERIFIED] = {
        icon: VerifiedIcon,
        color: "#4caf50",
        title: "kyc-profile.status.verified.title",
        description: "kyc-profile.status.verified.description",
    },
    _a);
